<outlaw-dialog-wrapper closeIcon="arrowLeft">
  @if (profile) {
    <div class="user-profile">
      <div class="avatar" [style]="getAvatarStyleObject()"></div>
      <div class="data">
        <div class="user-social">
          <div class="user-info">
            <div class="username">
              {{ profile.username }}
              @if (profile.types.length) {
                <div class="icon-wrapper">
                  <span class="icon"></span>
                </div>
              }
            </div>
            <div class="user-stats">
              @if (profile?.follower_count > 0) {
                <div class="item">{{ profile.follower_count }} followers</div>
              }
            </div>
          </div>
          @if (socialLinks.length) {
            <app-social-links [links]="socialLinks" />
          }
        </div>
        <app-follow-button [profile]="shortProfile" (followStatusChanged)="onFollowStatusChanged($event)" />
      </div>
    </div>
  }
  @if (!profile) {
    <app-community-loader />
  }
</outlaw-dialog-wrapper>
